<template>
  <div class="rescue global-rescue">
    <BackTop></BackTop>
    <div class="main">
      <Breadcrumb class="bread rescueBread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem to="/rescue">全球救援</BreadcrumbItem>
        <BreadcrumbItem class="bread-last">丰富的医疗转运经验</BreadcrumbItem>
      </Breadcrumb>
      <h3 class="rescue-bigtitle"
          style="margin-bottom:39px;">丰富的医疗转运经验</h3>
      <p class="experience-para"
         style="margin-bottom:68px;">
        北京威马捷通过近20年超过3000件国际医疗转运案件的经验积累，专业解析转运路线及转运方法，开发制作了自有的救援地图服务 系统AMS(Assistance Mapping System) ，为有需要的客户提供迅速并专业的就医协调及转运方案。</p>
      <h4 class="rescue-title">北京威马捷独自开发的全球医疗转运救援地图系统AMS</h4>
      <div class="experience-part">
        <p class="experience-para"
           style="margin-bottom:10px;">
          独创的AMS系统能够直观展现北京威马捷的转运成功案例以及为客户量身定制的转运流程信息。<br/> 信息数据化时代，我们将多年的国际转运案例转化为可视化数据，并参考这些数据定制新的转运方案，在不断增加的信息储备和服务品质中为客户提供更加专业的医疗转运服务。
          <br/> 同时我们提供的也是高品质服务与合理费用管理的完美方案。
          <br/> 北京威马捷方案=专业安全的医疗转运+高品质服务+费用管控
        </p>
      </div>
      <h4 class="more-case"
          style="margin:16px 0 22px 0;">在多样化的转运方式中累积经验</h4>
      <div class="experience-part"
           style="margin-bottom:80px;">
        <ul class="top-pic">
          <li>
            <div>
              <img :src="plane01"
                   alt="">
            </div>
            <h5>急救车转运</h5>
          </li>
          <li>
            <div>
              <img :src="plane02"
                   alt="">
            </div>
            <h5>民航客机转运</h5>
          </li>
          <li>
            <div>
              <img :src="plane03"
                   alt="">
            </div>
            <h5>医疗包机转运</h5>
          </li>
          <li>
            <div>
              <img :src="plane04"
                   alt="">
            </div>
            <h5>直升机转运</h5>
          </li>
          <li>
            <div>
              <img :src="plane05"
                   alt="">
            </div>
            <h5>高铁转运</h5>
          </li>
          <li>
            <div>
              <img :src="plane06"
                   alt="">
            </div>
            <h5>船舶转运</h5>
          </li>
        </ul>
        <div class="bom-pic">
          <img :src="plane07"
               alt="">
          <!-- <div class="left">
            <div></div>
            <h5>专业收录、解析全球转运经验的数据库</h5>
          </div>
          <div class="right">
            <div class="right-top">
              <div></div>
              <h5>紧急移送/
                <span>Evacuation</span>
              </h5>
            </div>
            <div class="right-bot">
              <div></div>
              <h5>转运回国/
                <span>Repatriation</span>
              </h5>
            </div>
          </div> -->
        </div>
      </div>
      <h4 class="rescue-title">供应商合作网络：医疗包机公司</h4>
      <div class="experience-part">
        <p class="experience-para"
           style="margin-bottom:39px;">
          威马捷与多家全球转运包机公司有着稳定的长期合作，携手为客户提供专业的跨国转运服务。<br/> 威马捷的转运服务以专业、安全、高效为前提，并根据客户需求作出数据筛选及整体路线规划，提供最妥善的解决方案。
        </p>
        <p class="more-case"
           style="margin:30px 0 10px 0;">覆盖全球的医疗包机合作网络</p>
        <div class="experience-map">
          <img :src="worldmap"
               alt="">
        </div>
        <p class="experience-para">
          ※威马捷在条件允许的情况下会优先选择民用航空进行医疗转运。<br/> 在保障患者身体状态的同时，综合考量转运时间及成本控制等因素后，从备选路线里选择最合理的转运方案。
        </p>
      </div>
      <h4 class="rescue-title">强大的合作网络及医疗顾问团队</h4>
      <div class="experience-part"
           style="margin-bottom:100px;">
        <p class="experience-para"
           style="margin-bottom:38px;">
          威马捷通过覆盖全球的合作医院网络及专业紧急救援团队为患者提供迅速高效的救援服务，同时有国内资深专家医疗顾问团队为患者 提供第二诊疗意见。
        </p>
        <div class="experience-team">
          <div class="team-cell">
            <h5>全球合作医疗网络 </h5>
            <div class="team-part">
              <img :src="team02"
                   alt="">
              <p>合作网络中囊括了全球紧急移送集中城市及中国国内的（能够接受重症患者）大型综合医院信息，确保转运流程顺畅</p>
            </div>
          </div>
          <span class="team-plus">+</span>
          <div class="team-cell">
            <h5>紧急救援及医疗顾问团队 </h5>
            <div class="team-part">
              <img :src="team01"
                   alt="">
              <p>具有航空医疗专业知识的全球紧急救援医疗团队 国内资深专家组成的医疗顾问团队</p>
            </div>
          </div>
        </div>
        <div class="experience-team"
             style="margin-top:67px;">
          <div class="team-cell2">
            <div class="team-part-more">
              <img :src="team03"
                   alt="">
              <h5>医疗顾问给出第二诊疗意见</h5>
              <p>医疗顾问团队由三甲医院临床经验丰富的专家医生组成，根据需要，针对当地医疗机构及主治医生的治疗方案给出第二诊疗意见。</p>
            </div>
          </div>
          <div class="team-cell2">

            <div class="team-part-more">
              <img :src="team04"
                   alt="">
              <h5>专业医疗团队陪同转运 </h5>
              <p>由航空医疗经验丰富的专业医疗救援团队全程陪护。在保障患者安全的同时，更让患者及家属感受到来自祖国救援保障的安心。</p>
            </div>
          </div>
          <div class="team-cell2">
            <div class="team-part-more">
              <img :src="team05"
                   alt="">
              <h5>安排回国后的接收医院 </h5>
              <p>协助患者安排归国后的接收医院，真正做到病床到病床的一站式转运安排。我们的合作网络遍布全国各个城市，方便患者就近（家）治疗。
              </p>
            </div>
          </div>
        </div>
      </div>
      <h4 class="rescue-title">参考：重症案件操作流程</h4>
      <div class="experience-part">
        <img :src="worldflow"
             alt=""
             style="width: 818px;display:block;margin:auto;">
      </div>
    </div>
  </div>
</template>
<script>
import Network from '@/assets/images/rescue/experience01.jpg';
import Experience from '@/assets/images/rescue/experience01.png';
import team01 from '@/assets/images/rescue/experience02.jpg'
import team02 from '@/assets/images/rescue/experience03.jpg'
import team03 from '@/assets/images/rescue/experience04.jpg'
import team04 from '@/assets/images/rescue/experience05.jpg'
import team05 from '@/assets/images/rescue/experience06.jpg'
import plane01 from '@/assets/images/rescue/experience07.jpg'
import plane02 from '@/assets/images/rescue/experience08.jpg'
import plane03 from '@/assets/images/rescue/experience09.jpg'
import plane04 from '@/assets/images/rescue/experience12.jpg'
import plane05 from '@/assets/images/rescue/experience13.jpg'
import plane06 from '@/assets/images/rescue/experience14.jpg'
import plane07 from '@/assets/images/rescue/experience15.png'
import worldmap from '@/assets/images/rescue/experience10.png'
import worldflow from '@/assets/images/rescue/experience11.png'
export default {
  data () {
    return {
      Network,
      Experience,
      team01,
      team02,
      team03,
      team04,
      team05,
      plane01,
      plane02,
      plane03,
      plane04,
      plane05,
      plane06,
      plane07,
      worldmap,
      worldflow
    }
  },
  mounted () {

  }
}
</script>
<style lang="less" scoped>
.top-pic {
  display: flex;
  width: 928px;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  li {
    width: 146px;
    div {
      width: 146px;
      height: 146px;
      background-color: #e9ebf4;
      img {
        width: 100%;
      }
    }
    h5 {
      text-align: center;
      color: #333130;
      font-size: 16px;
      margin: 20px 0;
    }
  }
}
.bom-pic {
  display: table;
  width: 928px;
  padding-top: 10px;
  img {
    width: 100%;
  }
  h5 {
    text-align: center;
    color: #333130;
    font-size: 16px;
    margin: 10px 0 20px 0;
    span {
      color: #ae1e10;
    }
  }
  .left {
    float: left;
    div {
      width: 540px;
      height: 350px;
      background-color: #e9ebf4;
    }
  }
  .right {
    margin-left: 12px;
    float: left;
    .right-top,
    .right-bot {
      div {
        width: 376px;
        height: 150px;
        background-color: #e9ebf4;
      }
    }
  }
}
.experience-part {
  border: none;
  padding: 0;
  margin: 0;
}
.rescue {
  background: #fff;
}
.main {
  margin-bottom: 100px;
}
.rescue-title {
  position: relative;
  font-size: 24px;
  color: #333130;
  line-height: 56px;
  padding-top: 20px;
  // text-indent: 32px;
  border-bottom: 3px solid #ae1e10;
  &::after {
    position: absolute;
    left: 0;
    bottom: 0;
    display: block;
    content: '';
    width: 320px;
    height: 2px;
    background: #ae1e10;
  }
}

.experience-bold {
  width: 906px;
  color: #333130;
  font-size: 24px;
  font-weight: bold;
  line-height: 36px;
  margin: 50px auto;
}

.experience-img {
  display: block;
  width: 810px;
  margin: 0 auto;
}
.experience-team {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  // margin: 0 40px 10px;
  margin: 0 20px;
  .team-plus {
    font-size: 56px;
    color: #2c2c2c;
    margin: 0 20px;
  }
  .team-cell {
    width: 414px;
    h5 {
      position: relative;
      font-size: 20px;
      color: #333130;
      line-height: 28px;
      margin-bottom: 28px;
    }
    .team-part {
      height: 270px;
      background: #e9ebf4;
      border-radius: 10px;
      overflow: hidden;
      p {
        font-size: 16px;
        color: #2c2c2c;
        line-height: 32px;
        // margin: 20px;
        padding: 16px;
      }
      img {
        width: 415px;
        height: 120px;
      }
    }
  }
  .team-cell2 {
    width: 289px;
    .team-part-more {
      position: relative;
      height: 378px;
      background: #e9ebf4;
      border-radius: 10px;
      padding: 4px 22px 0;
      img {
        position: absolute;
        left: 19px;
        top: -35px;
        z-index: 2;
        width: 237px;
        height: 59px;
        border: 4px solid #fff;
        border-radius: 10px;
        margin: 0 auto;
      }
      h5,
      p {
        font-size: 16px;
        color: #000000;
        line-height: 32px;
        margin-top: 42px;
      }
      h5 {
        margin-top: 37px;
        text-align: center;
        font-size: 20px;
      }
    }
  }
}
.experience-plane {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  width: 824px;
  margin: 50px auto 70px;
  img {
    width: 236px;
    height: 164px;
  }
}
.experience-map {
  width: 928px;
  margin-bottom: 39px;
  img {
    width: 100%;
  }
}
</style>